module.exports = __webpack_public_path__ + "img/icon-navigation-downward-arrow-red.a6884f1d.svg";